export default __webpack_public_path__ + "static/media/monkey4.093d0349.JPG";